import "./App.css";
import { useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Home from "./pages/Home";
import { Loader } from "./components";

const App = () => {
  const { authUser, loading } = useAuth();

  return (
    <main className='main'>
      <div className='container'>
        {loading ? <Loader /> : authUser ? <Home /> : <Login />}
      </div>
      <div className='launch-text'>
        {authUser?.email && (
          <p style={{ marginTop: 0 }}>
            You have logged in as <strong>{authUser.email}</strong>
          </p>
        )}
        <a
          href='https://chrome.google.com/webstore/detail/cloudmark-collaborative-b/ljcjjbhegcjomooleldkpiobchfghlkn'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: "underline" }}
        >
          Chrome extension
        </a>
        <a
          href='https://forms.gle/gHFwBxG1B7qg34ad8'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: "underline" }}
        >
          Feedback form
        </a>
        <a
          href='https://www.buymeacoffee.com/chiragkumar'
          target='_blank'
          rel='noreferrer'
          style={{
            display: "inline-block",
            backgroundColor: "var(--primary-color)",
            color: "#fff",
            padding: "12px 18px",
            borderRadius: 4,
            fontWeight: 600,
            fontSize: 18,
            fontStyle: "normal",
          }}
        >
          📖 Buy me a book
        </a>
      </div>
    </main>
  );
};

export default App;
